import { RETRY_REQUEST_COUNT_BASE, RETRY_REQUEST_DELAY_BASE } from '~sharedConfig'

import { ApiRetryMode } from '../enums/apiRetryMode'
import type { RetryConfig } from '../types/retryConfig'

export const retryConfigByMode: Record<ApiRetryMode, RetryConfig> = {
	[ApiRetryMode.BaseGet]: { retry: RETRY_REQUEST_COUNT_BASE, retryDelay: RETRY_REQUEST_DELAY_BASE }
}
